import React from 'react';

import {Box} from '@mui/material';
import {BannersChannelTypeEnum} from 'domain/usecases';
import Autoplay from 'embla-carousel-autoplay';
import {Carousel} from 'presentation/components';
import {CarrouselTypeEnum} from 'presentation/constants/carrouselTypeEnum';
import {useHostName} from 'presentation/hooks';
import {useAccountInformation, useMediaQueries} from 'presentation/pages/private/hooks';

import {useGetBannersQuery} from '../../query/useGetBannersQuery';
import {BannersLoading} from '../BannersLoading';
import {PRODUCT_TYPE} from './constants';
import {StyledImage, StyledLink} from './styles';

export function Banners() {
	const {isMobile, isDesktop} = useMediaQueries();
	const {
		dataHostNameState: {productCode},
	} = useHostName();
	const {
		beneficiary: {tipoPlanoC},
	} = useAccountInformation();

	const {
		data: banners,
		isError,
		isLoading,
	} = useGetBannersQuery({
		canal: BannersChannelTypeEnum.PORTAL,
		operadora: productCode[0].toString(),
		tipodeproduto: PRODUCT_TYPE[tipoPlanoC],
	});

	if (isError) {
		return null;
	}

	if (isLoading) {
		return <BannersLoading />;
	}

	const isEmpty = !banners || banners?.listaBanners.length === 0;

	return isEmpty ? null : (
		<Box>
			<Carousel
				hideButtons={isMobile}
				type={CarrouselTypeEnum.DOTS}
				plugins={[Autoplay({stopOnInteraction: false})]}
				isFullscreen
				slides={banners?.listaBanners.map((banner, index) => (
					<StyledLink
						key={index}
						href={banner.campos[0]?.link_externo ?? banner.campos[0]?.link_interno}
						target="_blank"
						rel="noreferrer noopener">
						<StyledImage
							src={
								isDesktop
									? banner.campos[0].img_desktop
									: banner.campos[0].img_responsiva
							}
							alt={
								isDesktop
									? banner.campos[0].img_desktop_descricao_alt
									: banner.campos[0].img_responsiva_descricao_alt
							}
						/>
					</StyledLink>
				))}
			/>
		</Box>
	);
}
